module.exports = __webpack_public_path__ + "img/success.f13fc66e.png";